import React, { useEffect, useRef, useState } from "react";
import { animate } from "framer-motion";
import AMRTypeTicker from "../AMRTypeTicker";
import { amrTypeCounts } from "../../data/amrIntegration";
import { useInViewAfterMount } from "../../hooks/useInViewAfterMount";
import { usePrefersReducedMotion } from "../../hooks/usePrefersReducedMotion";
import { SCOREBOARD_TIMING } from "./scoreboardTiming";

const totalAmrs = amrTypeCounts.reduce((sum, item) => sum + (item.count || 0), 0);

export default function HomeScoreboard({ compact = false }) {
  const panelRef = useRef(null);
  const reduceMotion = usePrefersReducedMotion();
  const inView = useInViewAfterMount(panelRef, { amount: 0.4, once: true });
  const play = !reduceMotion && inView;

  const [total, setTotal] = useState(totalAmrs);

  useEffect(() => {
    if (!play) {
      setTotal(totalAmrs);
      return undefined;
    }

    const controls = animate(0, totalAmrs, {
      duration: SCOREBOARD_TIMING.totalDur,
      delay: SCOREBOARD_TIMING.digitsAt,
      ease: [0.12, 0.82, 0.2, 1],
      onUpdate: (value) => setTotal(Math.round(value)),
    });
    return () => controls.stop();
  }, [play]);

  return (
    <div ref={panelRef} aria-labelledby="amr-scoreboard-heading">
      <h3 id="amr-scoreboard-heading" className="sr-only">{`${totalAmrs} vehicles across classes`}</h3>

      <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-gray-500">
        Projects Deployed
      </p>
      <div className={compact ? "mt-2 flex items-end gap-3" : "mt-3 flex items-end gap-4"}>
        <span
          className={
            compact
              ? "inline-block min-w-[3ch] text-5xl font-bold tabular-nums leading-none tracking-tight text-gray-900"
              : "inline-block min-w-[3ch] text-6xl font-bold tabular-nums leading-none tracking-tight text-gray-900 sm:text-7xl"
          }
          aria-hidden="true"
        >{total}</span>
        <span
          className="mb-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-gray-500"
          aria-hidden="true"
        >
          vehicles
        </span>
      </div>

      <AMRTypeTicker compact={compact} play={play} instant={!play} />
    </div>
  );
}
